import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pearsontechnology/aero-components';
import enhanceWithThemes from 'hocs/enhanceWithThemes';
import StyledLink from 'components/StyledLink';
import Builder from './builder';

import {
  EmptyPageWrapper,
  EmptyPageImageWrapper,
  MessageTitle,
  MessageBody,
  EmptyPageFooterWrapper,
  ButtonContainer,
} from './styles';
import themes from './themes';

const EmptyPage = ({ title, description, linkText, linkUrl, buttonText, buttonCallback }) => (
  <EmptyPageWrapper>
    <EmptyPageImageWrapper />
    <MessageTitle>
      {title}
    </MessageTitle>
    <MessageBody>
      {description}
    </MessageBody>
    <EmptyPageFooterWrapper>
      {linkText && <StyledLink to={linkUrl}>{linkText}</StyledLink>}
      {buttonText && (
        <ButtonContainer>
          <Button primary onClick={buttonCallback}>
            {buttonText}
          </Button>
        </ButtonContainer>
      )}
    </EmptyPageFooterWrapper>
  </EmptyPageWrapper>
);

EmptyPage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  buttonText: PropTypes.string,
  buttonCallback: PropTypes.func,
};

export default new Builder((args) => enhanceWithThemes(EmptyPage, themes(args.lightBackgroundImage, args.darkBackgroundImage)));
